@if (this.viaBeschikbaar) {
    @if (this.heeftVia) {
        <div style="width: 75%">
            <snelstart-ui-alert type="info">
                Er zijn vooraf ingevulde gegevens beschikbaar vanuit de Belastingdienst. Deze gegevens zijn in te zien
                via het
                klantdossier. De gegevens kunnen worden ingelezen in de aangifte, maar dat hoeft niet. Klik hieronder op
                de button
                'Via {{ this.selectedYear }} inlezen'. Op dat moment worden automatisch
                de gegevens vanuit de VIA overgezet in de aangifte. Indien de aangifte afwijkende informatie bevat ten
                opzichte
                van de aangifte dan wordt de aangifte overschreven met de gegevens uit de VIA.
            </snelstart-ui-alert>
        </div>
    } @else {
        <div style="width: 75%">
            <snelstart-ui-alert type="warning">
                Er zijn (nog) geen vooraf ingevulde gegevens beschikbaar voor {{ this.selectedYear }}. Als er een
                actieve
                machtiging is voor de VIA {{ this.selectedYear }} ga dan naar de module Machtigingen
                in het klantdossier en kies daar bij VIA machtiging {{ this.selectedYear }} voor de optie Via Ophalen.
                Binnen 24
                uur zal de VIA hier beschikbaar zijn.
            </snelstart-ui-alert>
        </div>
    }
} @else {
    <div style="width: 75%">
        <snelstart-ui-alert type="warning">
            Er zijn (nog) geen vooraf ingevulde gegevens beschikbaar voor {{ this.selectedYear }}. Als er een actieve
            machtiging
            is voor de VIA dan worden de gegevens automatisch door ons opgehaald op 1 maart {{ this.selectedYear + 1 }}.<br/>
        </snelstart-ui-alert>
    </div>
}

<div class="col-auto">
    <snelstart-ui-button [config]="configAangever"
                         [disabled]="!this.viaBeschikbaar || !this.heeftVia"
                         class="pt-1 custom-input-225"
                         icon="arrow-up-from-dotted-line"
                         type="primary">
        VIA {{ this.selectedYear }} aangever inlezen
    </snelstart-ui-button>
</div>

<div class="col-auto pt-1">
    <snelstart-ui-button [config]="configPartner"
                         [disabled]="!this.viaBeschikbaar || !this.heeftViaPartner"
                         class="pt-1 custom-input-225"
                         icon="arrow-up-from-dotted-line"
                         type="primary">
        VIA {{ this.selectedYear }} partner inlezen
    </snelstart-ui-button>
</div>
